export default __webpack_public_path__ + "static/media/Flag_of_Austria.d95c3edc.svg";